/******/ (() => { // webpackBootstrap
/*!***************************************!*\
  !*** ./src/global/global-extra-js.js ***!
  \***************************************/
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Fix: push .header-wrapper--overlay below the announcement bar when present.
// The wrapper is position:absolute so it would otherwise overlap the bar at top:0.
document.addEventListener('DOMContentLoaded', function () {
  var announcement = document.querySelector('.announcement');
  var headerWrapper = document.querySelector('.header-wrapper--overlay');
  if (announcement && headerWrapper) {
    var announcementHeight = function announcementHeight() {
      var textEl = announcement.querySelector('.announcement__text');
      var key = textEl === null || textEl === void 0 ? void 0 : textEl.dataset.text;
      var dismissed = key && sessionStorage.getItem(key) === 'hidden';
      // scrollHeight returns natural content height even when max-height:0
      return dismissed ? 0 : announcement.scrollHeight;
    };
    var applyPadding = function applyPadding(animate) {
      if (!animate) {
        headerWrapper.style.transition = 'none';
        headerWrapper.offsetHeight; // force reflow so 'none' takes effect
      }
      headerWrapper.style.paddingTop = announcementHeight() + 'px';
      if (!animate) {
        headerWrapper.offsetHeight; // force reflow before restoring transition
        headerWrapper.style.transition = '';
      }
    };
    applyPadding(false); // set immediately on load, no animation

    // Re-apply when bar opens (class removed) or user dismisses it (class added)
    new MutationObserver(function () {
      return applyPadding(true);
    }).observe(announcement, {
      attributes: true,
      attributeFilter: ['class']
    });
    window.addEventListener('resize', function () {
      return applyPadding(false);
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var loadMoreBtn = document.querySelector('#load-more');
  var grid = document.querySelector('#CollectionAjaxContent .product-grid-container');
  if (!loadMoreBtn || !grid) return;
  var loading = false;
  function loadMore() {
    return _loadMore.apply(this, arguments);
  }
  function _loadMore() {
    _loadMore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var nextUrl, _AOS$refreshHard, _AOS, res, html, parser, doc, newItems, newBtn, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!loading) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            nextUrl = loadMoreBtn.dataset.nextUrl;
            if (nextUrl) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            loading = true;
            loadMoreBtn.disabled = true;
            loadMoreBtn.textContent = 'Loading...';
            _context.p = 3;
            _context.n = 4;
            return fetch(nextUrl);
          case 4:
            res = _context.v;
            _context.n = 5;
            return res.text();
          case 5:
            html = _context.v;
            parser = new DOMParser();
            doc = parser.parseFromString(html, 'text/html');
            newItems = doc.querySelectorAll('#CollectionAjaxContent .grid__item');
            newItems.forEach(function (item) {
              return grid.appendChild(item);
            });
            newBtn = doc.querySelector('#load-more');
            if (newBtn) {
              loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
              loadMoreBtn.disabled = false;
              loadMoreBtn.textContent = 'Load More';
            } else {
              observer.disconnect();
              loadMoreBtn.remove();
            }
            if (typeof AOS !== 'undefined') (_AOS$refreshHard = (_AOS = AOS).refreshHard) === null || _AOS$refreshHard === void 0 || _AOS$refreshHard.call(_AOS);
            _context.n = 7;
            break;
          case 6:
            _context.p = 6;
            _t = _context.v;
            console.error('Load More failed:', _t);
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = 'Load More';
          case 7:
            _context.p = 7;
            loading = false;
            return _context.f(7);
          case 8:
            return _context.a(2);
        }
      }, _callee, null, [[3, 6, 7, 8]]);
    }));
    return _loadMore.apply(this, arguments);
  }
  var observer = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) loadMore();
  }, {
    rootMargin: '200px'
  });
  observer.observe(loadMoreBtn);
});
_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
  var getCart, _getCart, updateCartCount, openCartDrawer, showToast;
  return _regenerator().w(function (_context4) {
    while (1) switch (_context4.n) {
      case 0:
        showToast = function _showToast(msg) {
          var t = document.createElement('div');
          t.className = 'tile-atc__toast';
          t.textContent = msg || 'Added to cart';
          document.body.appendChild(t);
          requestAnimationFrame(function () {
            return t.classList.add('is-in');
          });
          setTimeout(function () {
            t.classList.remove('is-in');
            setTimeout(function () {
              return t.remove();
            }, 250);
          }, 1200);
        };
        openCartDrawer = function _openCartDrawer() {
          var toggles = document.querySelectorAll('[data-drawer="cart"], .js-cart-toggle, button[aria-controls*="cart"], a[href="#cart-drawer"]');
          if (toggles.length) {
            // Programmatically click the first toggle to open the drawer
            toggles[0].dispatchEvent(new MouseEvent('click', {
              bubbles: true
            }));
          } else {
            // Fire common events many Archetype/Motion builds listen for
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
          // Also fire generic "updated" events
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:change'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        };
        updateCartCount = function _updateCartCount(cart) {
          var count = cart.item_count || 0;
          var els = [document.querySelector('[data-cart-count]'), document.querySelector('.cart-count-bubble'), document.querySelector('.header__cart-count'), document.querySelector('.js-cart-count')].filter(Boolean);
          els.forEach(function (el) {
            el.textContent = String(count);
            el.style.display = count ? '' : 'none';
          });
        };
        _getCart = function _getCart3() {
          _getCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
            var r;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  _context3.n = 1;
                  return fetch('/cart.js');
                case 1:
                  r = _context3.v;
                  return _context3.a(2, r.json());
              }
            }, _callee3);
          }));
          return _getCart.apply(this, arguments);
        };
        getCart = function _getCart2() {
          return _getCart.apply(this, arguments);
        }; // Utility: fetch cart JSON
        // Utility: update header cart count (covers common Motion selectors)
        // Utility: open cart drawer (try multiple selectors; fallback = dispatch event)
        // Tiny toast
        // Intercept tile ATC submits
        document.addEventListener('click', /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var f, btn, id, res, cart, _t2;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.p = _context2.n) {
                case 0:
                  f = e.target.closest('form.tile-atc');
                  if (f) {
                    _context2.n = 1;
                    break;
                  }
                  return _context2.a(2);
                case 1:
                  e.preventDefault();
                  btn = f.querySelector('button');
                  if (btn) btn.disabled = true;
                  _context2.p = 2;
                  id = Number(f.dataset.variant || f.querySelector('[name="id"]').value);
                  _context2.n = 3;
                  return fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                      id: id,
                      quantity: 1
                    })
                  });
                case 3:
                  res = _context2.v;
                  if (res.ok) {
                    _context2.n = 4;
                    break;
                  }
                  throw new Error('add failed');
                case 4:
                  _context2.n = 5;
                  return getCart();
                case 5:
                  cart = _context2.v;
                  updateCartCount(cart);
                  openCartDrawer();
                  showToast('Added to cart');

                  // emit product-added event too (some themes listen for it)
                  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                      variantId: id,
                      cart: cart
                    }
                  }));
                  _context2.n = 7;
                  break;
                case 6:
                  _context2.p = 6;
                  _t2 = _context2.v;
                  console.warn(_t2);
                  // Worst case: go to cart so they see it
                  location.href = '/cart';
                case 7:
                  _context2.p = 7;
                  if (btn) btn.disabled = false;
                  return _context2.f(7);
                case 8:
                  return _context2.a(2);
              }
            }, _callee2, null, [[2, 6, 7, 8]]);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }());
      case 1:
        return _context4.a(2);
    }
  }, _callee4);
}))();
/******/ })()
;